import Vue from 'vue/dist/vue.common';
import MessasgeBus from './message-bus';

const COOKIE_KEY = 'part-search-cart';

const SF_URL = '/wp-json/atd-part-search/v1/request';


const PRODUCT_SERVICES = {
    'Mining Solutions' : 'Mining',
    'Crushing Solutions' : 'Crushing',
    'Engine Solutions' : 'Engines',
    'Cooling Solutions' : 'Cooling',
    'Oil & Gas' : 'Oil & Gas'
};

const REGIONS = {
    'global' : 'All',
    'australia' : 'Australia',
    'canada' : 'Canada',
    'chile' : 'Chile',
    'peru' : 'Peru',
    'united-states' : 'United States'
};

let PartSearchCart = function(el_id) {
    if(!document.getElementById(el_id)) {
        return null;
    }

    return new Vue({
        el: `#${el_id}`,
        data: {
            cart_id: null,
            cart_parts: [],
            just_added: '',
            cart_mode: 'cart',
            is_cart_open: false,
            confirmation: false,
            submitting: false,
            request_form: {
                FirstName: '',
                LastName: '',
                Company: '',
                Email: '',
                Phone: '',
                Street: '',
                City: '',
                State: '',
                'Postal Code': '',
                Country: '',
                Description: '',
                H_E_Parts_Products_Services__c: ''
            }
        },
        computed: {
            parts_string: function() {
                let parts = [];
                this.cart_parts.forEach((part) => {
                    parts.push(part.he_part_num[0]);
                });

                return parts.join(',');
            }
        },
        created: function() {
            let message_bus = MessasgeBus.getInstance();
            if(message_bus) {
                // console.log(this.parts_string);
                let parts = [];
                this.cart_parts.forEach((part) => {
                    parts.push(part.he_part_num[0]);
                });

                message_bus.$emit('part-string',parts.join(','));
            }
        },
        mounted: function() {
            let message_bus = MessasgeBus.getInstance();
            if(message_bus) {
                message_bus.$on('part-added', (e, b) => { this.addPartToCart(e, b); });
            }
            if(message_bus) {
                message_bus.$on('part-removed', (e) => { this.removePartFromCart(e); });
            }

            // let message_bus = MessasgeBus.getInstance();

            // check if cart cookie is set
            let cookie_cart_id = this.checkCartCookie();

            // if cart_id is set load cart from api
            if(cookie_cart_id) {
                this.loadCart(cookie_cart_id).then((results) => {
                    if(results && results.cart_id) {
                        this.cart_id = results.cart_id;
                    }

                    if(results && results.parts) {
                        this.cart_parts = results.parts;
                        this.updatePartsField();
                    }

                    if(!results) {
                        this.deleteCartCookie();
                    }
                });
            }
            if(message_bus) {
                // console.log(this.parts_string);
                let parts = [];
                this.cart_parts.forEach((part) => {
                    parts.push(part.he_part_num[0]);
                });

                message_bus.$emit('part-string',parts.join(','));
            }
        },

        methods: {
            addPartToCart(parts, modal) {
                // if product is already in cart, do nothing
                if(modal){
                    this.openCart(null);
                }
                console.log('open');
                let unique_parts = this.getUniqueParts(parts);

                this.just_added = unique_parts.length ? this.getPartNumbers(unique_parts).join(', ') : 'none';

                if(this.cart_id) {
                    // if cart already exists, update it
                    this.cart_parts = this.cart_parts.concat(unique_parts);

                    if(this.cart_parts.length) {

                        this.updateCart(this.cart_id, this.cart_parts).then((response) => {
                            if(response.parts) {
                                this.cart_parts = response.parts;
                                this.updatePartsField();
                            }
                        });
                    }
                }
                // if cart doesn't exist, create one
                else {
                    this.createCart(unique_parts).then((response) => {
                        this.cart_id = response.cart_id;
                        if(response.parts) {
                            this.cart_parts = response.parts;
                        }

                        this.createCartCookie(this.cart_id);
                        this.updatePartsField();
                    });
                }
                let message_bus = MessasgeBus.getInstance();
                if(message_bus) {
                    message_bus.$emit('part-string', this.parts_string);
                }
            },

            createCart(parts) {
                // let parts = new Array(part);
                return fetch(`/wp-json/atd/part-search-cart/new`, {
                    method: 'POST',
                    body: JSON.stringify({parts: parts})
                })
                .then(response => response.json());
            },

            loadCart(cart_id) {
                return fetch(`/wp-json/atd/part-search-cart/get/${cart_id}`, {
                    method: 'GET'
                })
                .then(response => response.json());
            },

            updateCart(cart_id, cart_parts) {
                return fetch(`/wp-json/atd/part-search-cart/update`, {
                    method: 'PUT',
                    body: JSON.stringify({
                        cart_id: cart_id,
                        parts: cart_parts
                    })
                })
                .then(response => response.json());
            },

            removePartFromCart(cart_parts) {
                return fetch(`/wp-json/atd/part-search-cart/update`, {
                    method: 'DELETE',
                    body: JSON.stringify({
                        parts: cart_parts
                    })
                })
                .then(response => response.json());
            },

            checkCartCookie(cookie_key = COOKIE_KEY) {
                var match = document.cookie.match(new RegExp('(^| )' + cookie_key + '=([^;]+)'));
                if (match) {
                    return match[2];
                }

                return null;
            },

            createCartCookie(cart_id) {
                document.cookie = `${COOKIE_KEY}=${cart_id}; expires=0; path=/`;
            },

            deleteCartCookie() {
                document.cookie = `${COOKIE_KEY}= ; expires="Thu, 01 Jan 1970 00:00:00 GMT"`;
            },

            isPartInCart(part) {
                let in_cart = false;

                this.cart_parts.forEach((cart_part) => {
                    if(cart_part.he_part_num[0] === part.he_part_num[0]) {
                        in_cart = true;
                    }
                });

                return in_cart;
            },

            getPartNumbers(parts) {
                let part_numbers = [];

                parts.forEach((part => {
                    part_numbers.push(part.he_part_num[0]);
                }));

                return part_numbers;
            },

            getUniqueParts(parts) {
                let unique_parts = [];
                let part_numbers = this.getPartNumbers(this.cart_parts);

                parts.forEach((part) => {
                    if(part_numbers.indexOf(part.he_part_num[0]) < 0) {
                        unique_parts.push(part);
                    }
                });

                return unique_parts;
            },

            switchCartMode(e, mode) {
                e && e.preventDefault();

                this.cart_mode = mode;

                this.updatePartsField();

            },

            closeCart(e) {
                e && e.preventDefault();

                this.just_added = false;
                this.is_cart_open = false;
                this.confirmation = false;
            },

            openCart(e) {
                e && e.preventDefault();

                this.cart_mode = 'cart';
                this.just_added = false;
                this.is_cart_open = true;
            },

            addMoreParts(e) {
                e && e.preventDefault();

                if(window.location.href.indexOf('/parts-inventory-search') >= 0) {
                    this.closeCart(null);
                }
                else {
                    window.location = '/parts-inventory-search';
                }
            },

            updatePartsField() {
                let field = document.getElementById('input_2_6');
                if(field) {
                    window.setTimeout(() => {
                        field.value = this.parts_string;
                    }, 0);
                }
            },

            clearCart() {
                this.deleteCartCookie();
                this.cart_id = null;
                this.cart_parts = [];
                this.just_added = '';
                this.cart_mode = 'cart';
            },

            clearItem(e, part_index) {
                e && e.preventDefault();

                this.cart_parts.splice(part_index, 1);
                this.updateCart(this.cart_id, this.cart_parts).then((response) => {
                    if(response.parts) {
                        this.updatePartsField();
                    }
                });
            },

            submitRequestForm(e) {
                e && e.preventDefault();

                this.submitting = true;

                let payload = Object.assign({}, this.request_form);
                payload.Parts = [];

                payload.HEPI_Website_Location__c = REGIONS['global'];
                let regionCookieValue = this.checkCartCookie('region');
                if(regionCookieValue && REGIONS[regionCookieValue]) {
                    payload.HEPI_Website_Location__c = REGIONS[regionCookieValue];
                }

                payload.H_E_Parts_Products_Services__c = [];

                this.cart_parts.forEach((part, i) => {
                    payload.Parts.push(Array.isArray(part.he_part_num) ? part.he_part_num.join(', ') : part.he_part_num);
                    payload[`Product[${i}][Equipment_Type__c]`] = Array.isArray(part.equipment_type) ? part.equipment_type.join(', ') : part.equipment_type;
                    payload[`Product[${i}][Division__c]`] = Array.isArray(part.division) ? part.division.join(', ') : part.division;
                    if(PRODUCT_SERVICES[payload[`Product[${i}][Division__c]`]]) {
                       payload.H_E_Parts_Products_Services__c.push(PRODUCT_SERVICES[payload[`Product[${i}][Division__c]`]]);
                    }
                    payload[`Product[${i}][H_E_Partner__c]`] = '';
                    payload[`Product[${i}][HEPI_Part__c]`] = Array.isArray(part.he_part_num) ? part.he_part_num.join(', ') : part.he_part_num;
                    payload[`Product[${i}][Make__c]`] = Array.isArray(part.make) ? part.make.join(', ') : part.make;
                    payload[`Product[${i}][Model__c]`] = Array.isArray(part.model) ? part.model.join(', ') : part.model;
                    payload[`Product[${i}][OEM_Part__c]`] = Array.isArray(part.oem_part_num) ? part.oem_part_num.join(', ') : part.oem_part_num;
                    payload[`Product[${i}][Part_Description__c]`] = Array.isArray(part.description) ? part.description.join(', ') : part.description;
                });

                let today = new Date();

                payload.Parts = payload.Parts.join(', ');
                payload.H_E_Parts_Products_Services__c  = payload.H_E_Parts_Products_Services__c.filter(onlyUnique).join('; ');
                payload.LeadSource = 'Website Part Inquiry';
                payload.Lead_Source_Details__c = 'Shopping Cart';
                payload.Source__c = 'Shopping Cart';
                payload.Date_Time_Submitted__c = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDay()} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;

                fetch(SF_URL, {
                    method: 'POST',
                    body: JSON.stringify(payload)
                }).then(() => {
                        this.clearCart();
                        this.cart_mode = 'form';
                        this.confirmation = true;
                        this.submitting = false;
                });
            }
        }
    });
}

const onlyUnique = function(value, index, self) {
    return self.indexOf(value) === index;
}

const JSON_to_URLEncoded = function(element,key,list){
    var list = list || [];
    if(typeof(element)=='object'){
        for (var idx in element) {
            JSON_to_URLEncoded(element[idx],key?key+'['+idx+']':idx,list);
        }
    } else {
        list.push(key+'='+encodeURIComponent(element));
    }
    return list.join('&');
}

export {PartSearchCart as default}



// WEBPACK FOOTER //
// ./js/part-search-cart.js